import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Modal } from "react-bootstrap";
import moment from 'moment';
import { v1 as uuid } from 'uuid'
import Select, { components } from 'react-select';
import { Link, useHistory } from 'react-router-dom';
import { Drawer, Button, Space, Timeline, Tooltip } from 'antd';

import { setCookie, getCookie } from '../common_component/cookie.js';
import formatNumber from '../common_component/formatNumber.js';
import { useAuthData } from "./auth-provider.js";
import { useTheme } from "./theme-provider.js";
import PageError from '../common_component/PageError.js';

export const EditPaymentDetails = (props) => {
    const [state, setstate] = useState(2);
    const history = useHistory()
    const { theme, dropdownStyleDark } = useTheme()
    const [failedPageMessage, setFailedPageMessage] = useState("Something went wrong. Please reload this page.")

    const [navtype, setnavtype] = useState("");
    const [open, setOpen] = useState(false);
    const [billDetails, setBillDetails] = useState(null);
    const [paymentDetails, setPaymentDetails] = useState(null);
    const [receiveGoodsRecords, setReceiveGoodsRecords] = useState([]);
    const [billHistoryDetails, setBillHistoryDetails] = useState([]);
    const [additonalDetailsFlag, setAdditonalDetailsFlag] = useState(false);

    const [progressModalShow, setProgressModalShow] = useState(false)
    const [progressStatus, setProgressStatus] = useState([])
    const [flowApiState, setFlowApiState] = useState(false)
    const [baseCurrency, setBaseCurrency] = useState(null)

    const [fileNames, setFileNames] = useState([])
    const [fileSessionUniqueId, setFileSessionUniqueId] = useState(uuid());

    const [Configuration_arr, setConfiguration_arr] = useState([{ denomination: [], notes: "" }]);
    const [PaymentNumber, setPaymentNumber] = useState("");
    const PaymentModeList = [{ label: "Bank Transfer", value: "Bank_Transfer" }, { label: "Cash", value: "Cash" }, { label: "Cheque", value: "Cheque" }, { label: "Credit Card", value: "Credit_Card" }];
    const PaymentTypeList = [{ label: "Vendor", value: "Vendor" }, { label: "Manufacturer", value: "Manufacturer" }];
    const [PaymentMode, setPaymentMode] = useState({ label: "Cash", value: "Cash" });

    const [DenominationModalShow, setDenominationModalShow] = useState(false);
    const [amtArray, setamtArray] = useState([]);
    const [billInfo, setBillInfo] = useState([]);
    const [billList, setBillList] = useState([]);
    const [PaymentAmount, setPaymentAmount] = useState(0);

    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [decimalPlace, setDecimalPlace] = useState(3);
    const [CurrencySymbol, setCurrencySymbol] = useState("");

    const [paymentType, setPaymentType] = useState(null);
    const [paymentValue, setPaymentValue] = useState(null);
    const [billListApiState, setBillListApiState] = useState(false);
    const [approvalChainPopup, setApprovalChainPopup] = useState(false)

    const [PaidThroughAccount, setPaidThroughAccount] = useState(null)
    const [PaymentValueList, setPaymentValueList] = useState([]);
    const [TotalPaymentValueList, setTotalPaymentValueList] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedTransactionSeries, setSelectedTransactionSeries] = useState(null);
    const [branchList, setBranchlist] = useState([]);
    const [transactionSeriesList, setTransactionSeriesList] = useState([]);
    const [PaidThroughAccountlist, setPaidThroughAccountlist] = useState([]);
    const [Notes, setNotes] = useState("");

    const [Payment_date, setPayment_date] = useState(moment().format('YYYY-MM-DD'));
    const [timezone_change, set_timezone_change] = useState("+00:00");
    const [AccountSelectionList, setAccountSelectionList] = useState([]);
    const [allAccountSelectionList, setAllAccountSelectionList] = useState([]);
    const [paymentApiState, setPaymentApiState] = useState(false);

    const [submitButtonState, setSubmitButtonState] = useState(false);
    const [references, setReferences] = useState("");
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    const [newHead, setNewHead] = useState({ name: "", code: "", uq_ac: "", sub: 0, parent: "", description: "" })
    const [addAccHeadModalShow, setAddAccHeadModalShow] = useState(false)
    const [submitButton, SetSubmitButton] = useState(false);

    const [accountheadList, setAccountHeadList] = useState([]);
    const [approvalInfo, setApprovalInfo] = useState(null);
    const [categoryList, setCategoryList] = useState([]);
    const apiController = useRef(new AbortController())

    var page_name = "edit-payment-details";

    const search_length = 1;

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    const readOnlyStyles = {
        backgroundColor: "lightgray",
        color: "gray",
        fontSize: "12px",
        border: "1px dotted gray",
        cursor: "text"
    }

    const trimDecimalPlaces = (amt, decimal_place) => {
        return Math.round(amt * Math.pow(10, decimal_place)) / Math.pow(10, decimal_place)
    }

    const onClose = () => {
        setOpen(false);
        setBillDetails(null);
        setReceiveGoodsRecords([]);
    };

    const checkDenominationValidation = (denominationArr, amount) => {
        const total_denomination = trimDecimalPlaces(denominationArr.reduce((p, o) => { return p + (o.count * parseInt(o.category)) }, 0), 3);
        if (total_denomination > Number(amount)) {
            swal("Oops!", "The total denomination cannot exceed the payment amount.", "warning");
            return false;
        }
        return true;
    }

    async function getBillDetails(id, flag) {
        setOpen(true);
        setAdditonalDetailsFlag(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-bill-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "bill_id": id, "document_flag": true, "history_flag": true, "id": id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setBillDetails(body.data);
            setReceiveGoodsRecords(body.data.associated_gr_list.map(x => { return { ...x, showReceiveGoodsDetails: false } }))
            setAdditonalDetailsFlag(false);
            setnavtype(flag == "payment_log" ? "Payment History" : "Overview")
        }
        else {
            throw "Payment additional details api error"
        }
    }

    async function getFinalizeBillListBySearch(search_val, user_id) {
        try {
            if (billListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setBillListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-bill-payment-by-search`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_val, "supplier_id": user_id, "user": user, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation == "success") {
                setBillListApiState(false)
                setBillList(body.data);
                return body.data;
            }
            else {
                throw "finalized invoice api list error"
            }
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    const newHeadSubmit = () => {
        //Name check
        if (newHead.uq_ac == "") {
            swal("Warning!", "Select a Category", "warning");
            return
        }
        var nexp = /^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 \/\\&|@#()\\[\]_.,:"']*)?$/;
        //Name check
        if (newHead.name == "") {
            swal("Warning!", "Head must have name", "warning");
            return
        }
        if (!newHead.name.match(nexp)) {
            swal("Warning!", "Head name cannot contain a number or symbols", "warning");
            return
        }
        let flag = false
        accountheadList.map((head) => {
            if (head.name.trim().toLowerCase() == newHead.name.toLowerCase()) {
                flag = true
            }
        })
        if (flag) {
            swal("Warning!", "Name already exists", "warning");
            return
        }

        let flag2 = false
        categoryList.map((head) => {
            if (head.category_name.trim().toLowerCase() == newHead.name.toLowerCase()) {
                flag = true
            }
        })
        if (flag2) {
            swal("Warning!", "Name Cannot be same of any Category", "warning");
            return
        }

        //Code check
        if (newHead.code == "") {
            swal("Warning!", "Head must have a code", "warning");
            return
        }
        let flag3 = false
        accountheadList.map((head) => {
            if (head.code.trim().toLowerCase() == newHead.code.toLowerCase()) {
                flag3 = true
            }
        })
        if (flag3) {
            swal("Warning!", "Code name already take", "warning");
            return
        }
        //Sub Parent check
        if (newHead.sub && !String(newHead.parent).trim().length) {
            swal("Warning!", "Sub-Head must have a parent", "warning");
            return
        }
        if (!newHead.sub && String(newHead.parent).trim().length) {
            swal("Warning!", "non Sub-Head should have a parent", "warning");
            return
        }

        let object = { ...newHead, page_name: page_name, organization_id: organization_id };

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        SetSubmitButton(true)
        axios.post(`${process.env.REACT_APP_SERVER_URL}/add-account-head`, object, headers).then((res) => {
            SetSubmitButton(false)
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success").then((value) => {
                    selectiveaccounthead("newly_added", newHead.name)
                    setAddAccHeadModalShow(false)
                });
            }
            else {
                swal("Oops!", res.data.message.substring(0, 30), "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    let timezone_change = body.data[0].timezone_value;
                    set_timezone_change(timezone_change);
                    setPayment_date(moment().utcOffset(timezone_change).format('YYYY-MM-DD'));
                }
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function selectiveaccounthead(flag, name) {
        setPaidThroughAccount(null);
        let arr = [
            { "category_name": "Assets", "headArray": [] },
            { "category_name": "Equity", "headArray": [] },
            { "category_name": "Income", "headArray": [] },
            { "category_name": "Bank", "headArray": [] }
        ]
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/selective-account-head`, { method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "headRequest": arr, "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            let allAccountList = [];

            const updatedData = body.data.map((obj) => {
                let headArray = obj.headArray.map((obj1) => {
                    let temp_obj = { label: obj1.name, value: obj1.hid, code: obj1.code };
                    allAccountList.push({
                        head_name: obj1.name,
                        hid: obj1.hid,
                        category_name: obj.category_name,
                        category_id: obj.cid,
                    });
                    if (obj1.name === name) setPaidThroughAccount(temp_obj);
                    return temp_obj;
                });

                return { label: obj.category_name, id: obj.cid, options: headArray };
            });
            setCategoryList(body.data);
            setAllAccountSelectionList(allAccountList);
            setPaidThroughAccountlist(updatedData);
        }
    }

    async function getSubSeriesData(val, key) {
        let sub_series_name = "";
        if (key == "Creditor") {
            sub_series_name = "creditor_payment";
        }
        if (key == "Vendor") {
            sub_series_name = "vendor_payment";
        }
        if (key == "Manufacturer") {
            sub_series_name = "manufacturer_payment";
        }
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-series-data-by-name`, { method: 'POST', body: JSON.stringify({ "email": user.email, "sub_series_name": sub_series_name, "transaction_series_id": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation == "success") {
            setPaymentNumber(`${body.data.prefix_value}-${parseInt(body.data.last_count) + 1}`)
        }
        else {
            swal("Alert!", body.message, "warning")
            return false
        }
    }

    const getProgressByStatus = async (bill_id) => {
        setFlowApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-payment-bill-status-timeline`, { method: 'POST', body: JSON.stringify({ "email": user.email, "bill_id": bill_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            setProgressStatus(body.data)
        }
        else {
            swal("Oops!", "Couldn't get order flow", "warning")
        }
        setFlowApiState(false)
    }


    async function getPaymentDetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-payment-details`, { method: 'POST', body: JSON.stringify({ "id": props.match.params.id, "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if ((body.operation == "success") && (body.data.length > 0)) {
            let info = body.data[0];
            if (info.add_status == "BILL_PAYMENT_PENDING_APPROVAL" || info.add_status == "BILL_PAYMENT_DRAFT") {
                setPaymentType({ label: info.payment_for, value: info.payment_for });
                setPaymentValue({ label: info.payment_user_name, value: info.payment_user_id });
                const bill_list = await getFinalizeBillListBySearch("", info.payment_user_id);
                setBillInfo(info.bill_info.map((obj) => {
                    let inv_d = bill_list.find(x => x.bill_id == obj.bill_id);
                    const due_amount = inv_d !== undefined ? (Number(inv_d.bill_amount) - Number(inv_d.paid_amount)) : 0;
                    return { ...obj, due_amount: due_amount, bill_date: moment(obj.bill_date).format('YYYY-MM-DD') }
                }));
                setPaymentNumber(info.transaction_number);
                setSelectedBranch({ label: info.branch_name, value: info.branch_id });
                setSelectedTransactionSeries({ label: info.series_name, value: info.transaction_series_id });
                setPaymentAmount(info.payment_amount);
                setPaymentMode({ label: info.payment_mode, value: info.payment_mode });
                setPayment_date(moment(info.payment_date).zone(timezone_change).format('YYYY-MM-DD'));
                setReferences(info.reference);
                setNotes(info.notes);
                setPaymentDetails(info);
            }
            else {
                throw (<span>{body.data[0].transaction_number} is not allowed to edit</span>)
            }
        }
        else {
            throw "No data is available"
        }
    }

    async function getBaseCurrency() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.length > 0) {
            setBaseCurrency(body[0])
        }
    }

    async function getApprovalDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-specific-approval`, {
            method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "key": "make_payment_approval", "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") }
        }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data !== null) {
                setApprovalInfo(body.data);
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p0 = getPaymentDetails()
            let p1 = getTimezoneInformation()
            let p2 = selectiveaccounthead("basic", "Petty Cash")
            let p3 = getBaseCurrency()
            let p4 = getApprovalDetails()
            Promise.all([p0, p1, p2, p3, p4])
                .then(async () => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    setFailedPageMessage(err);
                    console.log(err)
                    swal("Oops!", err, "error").then(() => { history.push("/payment-list") })
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (billInfo.length > 0 && billInfo.every(x => x.due_amount === 0)) {
            swal("Oops!", "All bills for this record have been fully paid. You need to cancel the record.", "warning").then(() => { history.push("/payment-list") })
        }
    }, [billInfo])

    const Reset_Denomination = (val, type) => {
        if (val === "INR") {
            setamtArray([
                { "category": 2000, "count": 0, "amount": 0 },
                { "category": 500, "count": 0, "amount": 0 },
                { "category": 200, "count": 0, "amount": 0 },
                { "category": 100, "count": 0, "amount": 0 },
                { "category": 50, "count": 0, "amount": 0 },
                { "category": 20, "count": 0, "amount": 0 },
                { "category": 10, "count": 0, "amount": 0 },
                { "category": 5, "count": 0, "amount": 0 },
                { "category": 2, "count": 0, "amount": 0 },
                { "category": 1, "count": 0, "amount": 0 }
            ]);
        }
        else {
            setamtArray([
                { "category": 2000, "count": 0, "amount": 0 },
                { "category": 500, "count": 0, "amount": 0 },
                { "category": 200, "count": 0, "amount": 0 },
                { "category": 100, "count": 0, "amount": 0 },
                { "category": 50, "count": 0, "amount": 0 },
                { "category": 20, "count": 0, "amount": 0 },
                { "category": 10, "count": 0, "amount": 0 },
                { "category": 5, "count": 0, "amount": 0 },
                { "category": 2, "count": 0, "amount": 0 },
                { "category": 1, "count": 0, "amount": 0 }
            ]);
        }
    }

    const updatePaymentSubmit = (val) => {
        var object = {};

        object.id = props.match.params.id;
        object.organization_id = organization_id;
        object.file_names = fileNames;
        object.unique_id = fileSessionUniqueId
        object.payment_for = paymentType.value;
        object.payment_user_id = paymentValue.value;
        object.branch_id = selectedBranch.value;
        object.transaction_series_id = selectedTransactionSeries.value;
        object.payment_number = PaymentNumber;
        object.payment_date = new Date(Payment_date);
        object.paid_through_account = PaidThroughAccount.value;
        object.account_category = PaidThroughAccountlist.find(x => x.options.map(a => a.value).includes(PaidThroughAccount.value)).id;
        object.payment_mode = PaymentMode.value;
        object.payment_amount = PaymentAmount;
        //object.configuration_arr = Configuration_arr[0];
        object.notes = Notes;

        object.bill_info = billInfo;
        object.page_name = page_name;

        object.save_flag = val
        object.organization_id = organization_id
        object.page_name = page_name;

        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-bill-payment`, object, headers).then((res) => {
            setSubmitButtonState(false);
            if (res.data.operation === "success") {
                swal("Great!", `Payment updated successfully!`, "success").then((value) => { window.location.href = `/payment-list` });
            }
            else if (res.data.operation === "No_Data_Modified") {
                swal("Oops!", "You need to modify something for updation!!", "error");
            }
            else if (res.data.message === "bill_already_paid") {
                swal("Oops!", `This ${res.data.data.join(",")} Bill Number already paid.Please remove this bill before proceeding!!`, "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const validatePayment = () => {
        if (paymentType == null) {
            swal("Oops!", "Payment for field cannot be empty.", "warning");
            return false
        }
        if (paymentValue == null) {
            swal("Oops!", `${paymentType.value} name cannot be empty.`, "warning");
            return false
        }
        if (selectedBranch == null) {
            swal("Oops!", "Branch cannot be empty", "warning");
            return false
        }
        if (selectedTransactionSeries == null) {
            swal("Oops!", "Transaction Series cannot be empty", "warning");
            return false
        }
        if (PaidThroughAccount == null) {
            swal("Oops!", "Paid Through Account cannot be empty", "warning");
            return false
        }
        const total_denomination = trimDecimalPlaces(amtArray.reduce((p, o) => { return p + (o.count * parseInt(o.category)) }, 0), 3);
        if (total_denomination > Number(PaymentAmount)) {
            swal("Oops!", "The total denomination cannot exceed the payment amount.", "warning");
            return false
        }
        for (let i = 0; i < billInfo.length; i++) {
            let obj = billInfo[i]
            if (obj.bill_number == null) {
                swal("Oops!", "Choose a Bill Number", "error");
                return
            }
            if (obj.due_amount == 0) {
                swal("Oops!", `The due amount is already zero. Please remove this bill(${obj.bill_number}) before proceeding.`, "error");
                return
            }
            if (obj.payment_amount == 0) {
                swal("Oops!", `Payment amount must be greater than zero (${obj.bill_number})`, "error");
                return
            }
            if (obj.payment_amount > obj.due_amount) {
                swal("Oops!", `Payment cannot exceed the due amount (${obj.bill_number})`, "error");
                return
            }
        }
        return true
    }

    const Accountheadwisepaymentmode = (val) => {
        console.log(allAccountSelectionList);
        if (allAccountSelectionList.find(option => option.hid == val.value).category_name == "Cash") {
            setPaymentMode({ label: "Cash", value: "Cash" });
        }
        if (allAccountSelectionList.find(option => option.hid == val.value).category_name == "Bank") {
            setConfiguration_arr([{ date: "", bank_name: allAccountSelectionList.find(option => option.hid == val.value).head_name, transaction_id: "", notes: "" }]);
            setPaymentMode({ label: "Bank Transfer", value: "Bank_Transfer" });
        }
    }

    useEffect(() => {
        if ((PaymentMode !== null && baseCurrency !== null)) {
            Config_set_up(PaymentMode.value);
        }
    }, [PaymentMode, baseCurrency])

    const Config_set_up = (val) => {
        if (val == "Cheque") {
            setConfiguration_arr([{ cheque_no: "", bank_name: "", cheque_date: "", notes: "" }]);
        }
        else if (val == "Bank_Transfer") {
            setConfiguration_arr([{ date: "", bank_name: "", transaction_id: "", notes: "" }]);
        }
        else if (val == "Credit_Card") {
            setConfiguration_arr([{ card_no: "", card_holder_name: "", expiry_date: "", notes: "" }]);
        }
        else {
            Reset_Denomination(baseCurrency.currency_code, "Set");
            setConfiguration_arr([{ denomination: [], notes: "" }]);
        }
    }

    const clear_bill_details = () => {
        let temp = billInfo.map(x => { return { ...x } });
        temp.map((obj, index) => {
            obj.bill_number = null;
            obj.bill_id = null;
            obj.bill_date = "";
            obj.bill_amount = 0;
            obj.due_amount = 0;
            obj.payment_amount = 0;
            obj.adjust_amount_arr = [];
        })
        setBillInfo(temp);
    }

    useEffect(() => {
        if (billInfo.length > 0 && billInfo.every(bill => bill.bill_id !== null)) {
            setPaymentAmount(billInfo.reduce((p, o) => { return p + ((Number(o.bill_currency.exchange_rate.organization.rate) / Number(o.bill_currency.exchange_rate.bill.rate)) * Number(o.payment_amount)) }, 0));
        }
    }, [billInfo])

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Edit Payment Details</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/purchase/make_payment`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                    </div>
                </div>
                <div>
                    {
                        ((!approvalInfo || approvalInfo.type === "not_configure") && state === 1) &&
                        <>
                            <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6">
                                <span className="svg-icon svg-icon-2tx svg-icon-warning me-4"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                    <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor"></rect>
                                    <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor"></rect>
                                </svg>
                                </span>
                                <div className="d-flex flex-stack flex-grow-1 ">
                                    <div className=" fw-semibold">
                                        <div className="fs-6 text-gray-700 ">Make Payment Approval Part Not Configured yet. Configure this, From <Link to={"/approvals"}>Approval Page</Link>.</div>
                                    </div>
                                </div>
                            </div><br />
                        </>
                    }
                    <div className="card">
                        <div className="card-body pt-6">
                            {
                                state == 1 ?
                                    <>
                                        <div className="row mb-sm-5 gx-0 ">
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Payment For</label>
                                                <Select
                                                    options={PaymentTypeList}
                                                    //onChange={(val) => { setPaymentType(val); getExpenseUser("", val.value); getSubSeriesData(selectedTransactionSeries.value, val.value) }}
                                                    value={paymentType}
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    isDisabled
                                                />
                                            </div>
                                            {paymentType !== null &&
                                                <div className="col-md-4 px-1 mb-2">
                                                    <label className="required fs-5 fw-bold mb-2">{paymentType.value} Name</label>
                                                    <Select
                                                        options={PaymentValueList}
                                                        //onChange={(val) => { setPaymentValue(val); getFinalizeBillListBySearch("", val.value); }}
                                                        value={paymentValue}
                                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                        isDisabled
                                                    />
                                                </div>}
                                            <div className="col-md-4">
                                                <label className="required fs-5 fw-bold mb-2">Payment Date</label>
                                                <input type="date" className="form-control" placeholder="Sales Start Date" value={Payment_date}
                                                    onChange={(e) => {
                                                        setPayment_date(e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-sm-5 gx-0 ">
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Branch:</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                                    onChange={(val) => {
                                                        swal("Alert!", "Please verify applicable taxes for selected items", "info")
                                                        setSelectedBranch(val);
                                                        setSelectedTransactionSeries(null)
                                                    }}
                                                    value={selectedBranch}
                                                    isDisabled
                                                    placeholder="Select Branch"
                                                />
                                            </div>
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Transaction Series:</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={selectedBranch != null && transactionSeriesList.filter(x => branchList.find(a => a.branch_id == selectedBranch.value).transaction_series_id.split(",").includes(x.transaction_series_id)).map(x => { return { label: x.series_name, value: x.transaction_series_id } })}
                                                    onChange={(val) => { setSelectedTransactionSeries(val); getSubSeriesData(val.value, paymentType.value) }}
                                                    value={selectedTransactionSeries}
                                                    placeholder="Select Transaction Series"
                                                    isDisabled
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="required fs-5 fw-bold mb-2">Transaction Number</label>
                                                <input type="text" className="form-control form-control-solid" value={PaymentNumber} readOnly style={readOnlyStyles} />
                                            </div>
                                        </div>

                                        <div className="row mb-5">
                                            <div className="col-md-6">
                                                <label className="required fs-5 fw-bold mb-2">Paid Through</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={PaidThroughAccountlist}
                                                    onChange={(val) => { setPaidThroughAccount(val); Accountheadwisepaymentmode(val); }}
                                                    value={PaidThroughAccount}
                                                    components={{
                                                        MenuList: (props) => {
                                                            return (
                                                                <components.MenuList  {...props}>
                                                                    {props.children}
                                                                    <div className='d-flex justify-content-center'>
                                                                        <button className='btn btn-success rounded btn-sm my-1' onClick={() => { setAddAccHeadModalShow(true) }} >&#10011; Add  Account head</button>
                                                                    </div>
                                                                </components.MenuList >
                                                            )
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="fs-5 fw-bold mb-2">Payment Mode</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={PaymentModeList}
                                                    onChange={(val) => { setPaymentMode(val) }}
                                                    value={PaymentMode}
                                                //isClearable
                                                />
                                                {PaymentAmount > 0 &&
                                                    <a onClick={(e) => { setDenominationModalShow(true); }} className="cursor-pointer">{PaymentMode != null && <span className="text-primary fs-6">Configure {PaymentMode.label} Mode</span>}</a>}
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-6 fv-row">
                                                <label className="fs-5 fw-bold mb-2">Reference</label>
                                                <input id="Invoice" type="text" className="form-control form-control-solid" value={references} onChange={(e) => { setReferences(e.target.value) }} />
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="table-responsive">
                                            <div className='container-fluid'>
                                                {
                                                    billInfo.map((obj, i) => {
                                                        return (
                                                            <div key={i} className='container bg-secondary my-2 p-5 rounded'>
                                                                <div className='d-flex align-items-center justify-content-between mb-3'>
                                                                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                                                                        <div className='fs-4 fw-bold'>Bill: #{i + 1}
                                                                            {(obj.bill_number !== null && obj.due_amount == 0) && <span className="text-danger ms-5">This bill has been fully paid. Please remove it.</span>}
                                                                        </div>
                                                                        {(obj.bill_number !== null && billList.find(x => x.bill_id == obj.bill_id) !== undefined) &&
                                                                            <>
                                                                                {/* <a class="cursor-pointer" onClick={() => { getBillDetails(obj.bill_id, "payment_log") }}><span class="badge py-3 px-4 fs-7 badge-light-warning">Pending: {obj.bill_currency.currency_symbol} {billList.find(x => x.bill_id == obj.bill_id).pending_amount}</span></a> */}
                                                                                <a class="cursor-pointer" onClick={() => { getBillDetails(obj.bill_id, "payment_log") }}><span class="badge py-3 px-4 fs-7 badge-light-success">Paid Amount: {obj.bill_currency.currency_symbol} {billList.find(x => x.bill_id == obj.bill_id).paid_amount}</span></a>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                    <div>
                                                                        {
                                                                            billInfo.length > 1 &&
                                                                            <button className='btn btn-link text-hover-danger mx-3'
                                                                                onClick={() => {
                                                                                    let t = billInfo.map(x => { return { ...x } })
                                                                                    t.splice(i, 1)
                                                                                    setBillInfo(t)
                                                                                }}
                                                                            >&#10006;</button>
                                                                        }
                                                                    </div>

                                                                </div>

                                                                <div className="row mb-5 gx-0 ">
                                                                    <div className="col-md-5 px-1 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2 required">Bill No.</label>
                                                                        <Select
                                                                            options={billList.map(x => { return { label: x.bill_number, value: x.bill_id } })}
                                                                            value={obj.bill_number == null ? null : { label: obj.bill_number, value: obj.bill_id }}
                                                                            onChange={(val) => {
                                                                                if (billInfo.find(a => a.bill_id == val.value) !== undefined) {
                                                                                    swal("Warning!", "Bill already exists", "warning");
                                                                                    return
                                                                                }

                                                                                let inv_d = billList.find(x => x.bill_id == val.value)
                                                                                const due_amount = Number(inv_d.bill_amount) - Number(inv_d.paid_amount)
                                                                                if (due_amount > 0) {
                                                                                    let t = billInfo.map(x => { return { ...x } })
                                                                                    t[i].bill_number = val.label
                                                                                    t[i].bill_id = val.value
                                                                                    t[i].bill_amount = inv_d.bill_amount > 0 ? inv_d.bill_amount : 0
                                                                                    t[i].due_amount = due_amount > 0 ? due_amount : 0
                                                                                    t[i].payment_amount = due_amount > 0 ? due_amount : 0
                                                                                    t[i].bill_date = moment(inv_d.bill_date).format("YYYY-MM-DD")
                                                                                    t[i].bill_currency = inv_d.bill_currency
                                                                                    setBillInfo(t);
                                                                                }
                                                                                else {
                                                                                    swal("Oops!", `This bill can't select because bill amount already processed`, "warning");
                                                                                    return
                                                                                }

                                                                            }}
                                                                            onInputChange={(val) => {
                                                                                if (val.length > search_length && paymentValue !== null) {
                                                                                    getFinalizeBillListBySearch(val, paymentValue.value)
                                                                                }
                                                                            }}
                                                                            onMenuClose={() => {
                                                                                if (paymentValue !== null) {
                                                                                    getFinalizeBillListBySearch("", paymentValue.value)
                                                                                }
                                                                            }}
                                                                            isLoading={billListApiState}
                                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                            placeholder="Choose the Bill"
                                                                        />
                                                                        {obj.bill_number !== null &&
                                                                            <>
                                                                                <a onClick={(e) => { getBillDetails(obj.bill_id, "") }} className="cursor-pointer"><span className="text-primary fs-6">View Bill</span></a>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                    <div className="col-md-3 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2">Bill Date</label>
                                                                        <input type="date" className="form-control form-control-solid" value={obj.bill_date} readOnly style={readOnlyStyles}
                                                                            onChange={(e) => {
                                                                                let t = billInfo.map(x => { return { ...x } })
                                                                                t[i].bill_date = e.target.value
                                                                                setBillInfo(t);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 px-1 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2">Bill Amount</label>
                                                                        <div className="input-group input-group-solid" style={readOnlyStyles}>
                                                                            <span className="input-group-text">{obj.bill_number !== null && obj.bill_currency.currency_symbol}</span>
                                                                            <input type="number" className="form-control" value={obj.bill_amount.toString()} readOnly />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3 px-1 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2">Due Amount</label>
                                                                        <div className="input-group input-group-solid" style={readOnlyStyles}>
                                                                            <span className="input-group-text">{obj.bill_number !== null && obj.bill_currency.currency_symbol}</span>
                                                                            <input type="number" className="form-control" value={obj.due_amount.toString()} readOnly />
                                                                        </div>
                                                                        {/*!obj.invoice_new && 
                                                                                <a onClick={(e) => { pay_full_amount(obj, i, "individual") }} className="cursor-pointer"><span className="text-primary fs-6">Pay full amount</span></a>
                                                                            */}
                                                                    </div>


                                                                    <div className="col-md-3 px-1 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2 required">Payment Amount</label>
                                                                        <div className="input-group input-group-solid">
                                                                            <span className="input-group-text" >{obj.bill_number !== null && obj.bill_currency.currency_symbol}</span>
                                                                            <input type="number" className="form-control" value={obj.payment_amount.toString()}
                                                                                onChange={(event) => {
                                                                                    let temp = billInfo.map(x => { return { ...x } });
                                                                                    let amount = event.target.value == "" ? 0 : parseFloat(event.target.value);
                                                                                    if (amount >= 0) {
                                                                                        let warning_flag = false;
                                                                                        if ((obj.bill_amount - obj.due_amount) !== 0 && amount > (obj.bill_amount - obj.due_amount)) {
                                                                                            swal("Oops!", "Amount cannot be greater than Due Amount", "warning");
                                                                                            temp[i].payment_amount = obj.due_amount;
                                                                                            warning_flag = true;
                                                                                        }
                                                                                        // if (obj.bill_amount !== 0 && amount > obj.bill_amount) {
                                                                                        //     swal("Oops!", "Amount cannot be greater than Bill Amount", "warning");
                                                                                        //     temp[i].payment_amount = obj.due_amount;
                                                                                        //     warning_flag = true;
                                                                                        // }
                                                                                        // console.log("warning_flag",warning_flag)
                                                                                        if (warning_flag == false) {
                                                                                            temp[i].payment_amount = amount;
                                                                                        }
                                                                                        console.log(temp)
                                                                                        setBillInfo(temp);
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        {(obj.bill_id !== null && obj.bill_currency.exchange_rate.organization.quote_curr !== obj.bill_currency.exchange_rate.bill.quote_curr) &&
                                                                            <span className="text-primary fs-6">1 {obj.bill_currency.exchange_rate.organization.quote_curr} = {(Number(obj.bill_currency.exchange_rate.organization.rate) / Number(obj.bill_currency.exchange_rate.bill.rate))} {obj.bill_currency.exchange_rate.bill.quote_curr}</span>}
                                                                        {/* {obj.bill_number !== null &&
                                                                                <>
                                                                                    <a onClick={(e) => { setProgressModalShow(true); getProgressByStatus(obj.bill_id); }} className="cursor-pointer"><span className="text-primary fs-6">View Amount</span></a>
                                                                                </>
                                                                            } */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <button className='btn btn-primary btn-sm m-3' onClick={() => { setBillInfo([...billInfo, { bill_number: null, bill_id: null, bill_currency: baseCurrency, bill_date: "", bill_amount: 0, due_amount: 0, payment_amount: 0, adjust_amount_arr: [] }]) }}>+ Add Bill</button>
                                            </div>
                                            <div className="d-flex flex-stack bg-success rounded-3 p-6 mb-11">
                                                <div className="fs-6 fw-bold text-white">
                                                    <span className="d-block lh-1 mb-2">Payment Amount</span>
                                                </div>
                                                <div className="fs-6 fw-bold text-white text-end">
                                                    <span className="d-block lh-1 mb-2">{baseCurrency.currency_symbol}&nbsp;{formatNumber(PaymentAmount, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <br />
                                        <div className="row mb-5">
                                            <div className="col-md-12 my-2">
                                                <label className="fs-5 fw-bold mb-2">Notes</label>
                                                <textarea className="form-control form-control-solid" rows="3" value={Notes} onChange={(e) => { setNotes(e.target.value) }} placeholder={""}></textarea>
                                            </div>
                                        </div>
                                        {
                                            write && (paymentDetails != null && paymentDetails.add_status == "BILL_PAYMENT_DRAFT") &&
                                            <button type="button" className="btn btn-lg btn-primary mt-15 mx-3 rounded" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { validatePayment() && updatePaymentSubmit(false) }}>
                                                <span className="indicator-label">Save as Draft</span>
                                                <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        }

                                        {
                                            user_role == "Admin" && write &&
                                            <button type="button" className="btn btn-lg btn-info mt-15 mx-3 rounded" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { validatePayment() && updatePaymentSubmit(true) }}>
                                                {(approvalInfo !== null && approvalInfo.type == "not_configure") ? <span className="indicator-label">Save & approve</span> : <span className="indicator-label">Save</span>}
                                                <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        }
                                    </>
                                    :
                                    <>
                                        {
                                            state == 2 ?
                                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                :
                                                <PageError message={failedPageMessage}>
                                                    <Link to={`/payment-list`} className="btn btn-sm btn-primary me-3 rounded cursor-pointer">Go to Payment List</Link>
                                                </PageError>
                                        }
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={DenominationModalShow} onHide={() => { setDenominationModalShow(false) }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Configure {PaymentMode.label} Mode</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setDenominationModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container' style={{ overflowY: "scroll", height: "21rem" }}>
                        {PaymentMode.value == "Cash" && baseCurrency !== null ?
                            <>
                                <div className="table-responsive mb-8">
                                    <table className="table align-end gs-0 gy-4 my-0">
                                        <thead>
                                            <tr>
                                                <th className="min-w-100px">Amount</th>
                                                <th className="min-w-75px align-items-center text-center">Count</th>
                                                <th className="text-end min-w-75px">Total Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                amtArray.map((obj3, indx3) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td className="py-0">
                                                                    <div className="" style={{ verticalAlign: "middle", lineHeight: "40px" }}>
                                                                        <span className="fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 me-1">{baseCurrency.currency_symbol} {obj3.category}</span>
                                                                    </div>
                                                                </td>
                                                                <td className="py-0">
                                                                    <div className="position-relative d-flex align-items-center justify-content-center" data-kt-dialer="true" data-kt-dialer-min="1" data-kt-dialer-max="10" data-kt-dialer-step="1" data-kt-dialer-decimals="0">
                                                                        <button type="button" className="btn btn-icon btn-sm btn-light btn-icon-gray-400"
                                                                            onClick={() => {
                                                                                if (obj3.count > 0) {
                                                                                    let temp = amtArray.map(a => { return { ...a } })
                                                                                    temp[indx3].count = parseInt(obj3.count) - 1;
                                                                                    temp[indx3].amount = temp[indx3].count * parseInt(obj3.category);
                                                                                    setamtArray(temp);
                                                                                    let temp_config = Configuration_arr.map(a => { return { ...a } })
                                                                                    temp_config[0].denomination = temp
                                                                                    setConfiguration_arr(temp_config)
                                                                                }
                                                                            }}>
                                                                            <span className="svg-icon svg-icon-3x"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                                                            </svg>
                                                                            </span>
                                                                        </button>
                                                                        <input type="text" className="form-control border-0 text-center px-0 fs-3 fw-bold text-gray-800 w-30px" placeholder="Amount" name="manageBudget" readonly="" min="0" value={obj3.count} />
                                                                        <button type="button" className="btn btn-icon btn-sm btn-light btn-icon-gray-400"
                                                                            onClick={() => {
                                                                                let temp = amtArray.map(a => { return { ...a } });
                                                                                temp[indx3].count = parseInt(obj3.count) + 1;
                                                                                temp[indx3].amount = temp[indx3].count * parseInt(obj3.category);
                                                                                if (checkDenominationValidation(temp, PaymentAmount)) {
                                                                                    setamtArray(temp);
                                                                                    let temp_config = Configuration_arr.map(a => { return { ...a } })
                                                                                    temp_config[0].denomination = temp
                                                                                    setConfiguration_arr(temp_config);
                                                                                }
                                                                            }}>
                                                                            <span className="svg-icon svg-icon-3x"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
                                                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                                                            </svg></span>
                                                                        </button>
                                                                    </div>

                                                                </td>

                                                                <td className="text-end py-0">
                                                                    <div style={{ verticalAlign: "middle", lineHeight: "40px" }}>
                                                                        <span className="d-block lh-1 mb-2">{baseCurrency.currency_symbol} {obj3.amount}</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table><hr />
                                    <div className="row">
                                        <div className="col-3">
                                            <span className="fw-bold text-primary fs-3">Subtotal</span>
                                        </div>
                                        <div className="col-3"></div>
                                        <div className="col-3">
                                        </div>
                                        <div className="col-3 text-end">
                                            <span className="fw-bold text-primary fs-3">{baseCurrency.currency_symbol} {trimDecimalPlaces(amtArray.reduce((p, o) => { return p + (o.count * parseInt(o.category)) }, 0), 3)}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className="col-md-12 my-2">
                                        <label className="fs-5 fw-bold mb-2">Notes</label>
                                        <textarea className="form-control form-control-solid" rows="3" value={Configuration_arr[0].notes}
                                            onChange={(e) => {
                                                let temp = Configuration_arr.map(a => { return { ...a } })
                                                temp[0].notes = e.target.value
                                                setConfiguration_arr(temp)
                                            }}
                                            placeholder={""}>
                                        </textarea>
                                    </div>
                                </div>
                            </>
                            :
                            PaymentMode.value == "Cheque" ?
                                <>
                                    <div className="row mb-5">
                                        <div className="col-md-10">
                                            <label className="required fs-5 fw-bold mb-2">Bank Name</label>
                                            <input type="text" className="form-control form-control-solid" value={Configuration_arr[0].bank_name}
                                                onChange={(e) => {
                                                    let temp = Configuration_arr.map(a => { return { ...a } })
                                                    temp[0].bank_name = e.target.value
                                                    setConfiguration_arr(temp)
                                                }} />
                                        </div>
                                    </div>
                                    <div className="row mb-5">
                                        <div className="col-md-5">
                                            <label className="required fs-5 fw-bold mb-2">Cheque Number</label>
                                            <input type="text" className="form-control form-control-solid" value={Configuration_arr[0].cheque_no}
                                                onChange={(e) => {
                                                    let temp = Configuration_arr.map(a => { return { ...a } })
                                                    temp[0].cheque_no = e.target.value
                                                    setConfiguration_arr(temp)
                                                }} />
                                        </div>
                                        <div className="col-md-5">
                                            <label className="required fs-5 fw-bold mb-2">Cheque Date</label>
                                            <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={Configuration_arr[0].cheque_date}
                                                onChange={(e) => {
                                                    let temp = Configuration_arr.map(a => { return { ...a } })
                                                    temp[0].cheque_date = e.target.value
                                                    setConfiguration_arr(temp)
                                                }} />
                                        </div>
                                    </div>
                                    <div className="row mb-5">
                                        <div className="col-md-12 my-2">
                                            <label className="fs-5 fw-bold mb-2">Notes</label>
                                            <textarea className="form-control form-control-solid" rows="3" value={Configuration_arr[0].notes}
                                                onChange={(e) => {
                                                    let temp = Configuration_arr.map(a => { return { ...a } })
                                                    temp[0].notes = e.target.value
                                                    setConfiguration_arr(temp)
                                                }}
                                                placeholder={""}>
                                            </textarea>
                                        </div>
                                    </div>
                                </>
                                :
                                PaymentMode.value == "Bank_Transfer" ?
                                    <>
                                        <div className="row mb-5">
                                            <div className="col-md-10">
                                                <label className="required fs-5 fw-bold mb-2">Bank Name</label>
                                                <input type="text" className="form-control form-control-solid" value={Configuration_arr[0].bank_name}
                                                    onChange={(e) => {
                                                        let temp = Configuration_arr.map(a => { return { ...a } })
                                                        temp[0].bank_name = e.target.value
                                                        setConfiguration_arr(temp)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-5">
                                                <label className="required fs-5 fw-bold mb-2">Transaction ID</label>
                                                <input type="text" className="form-control form-control-solid" value={Configuration_arr[0].transaction_id}
                                                    onChange={(e) => {
                                                        let temp = Configuration_arr.map(a => { return { ...a } })
                                                        temp[0].transaction_id = e.target.value
                                                        setConfiguration_arr(temp)
                                                    }} />
                                            </div>
                                            <div className="col-md-5">
                                                <label className="required fs-5 fw-bold mb-2">Date</label>
                                                <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={Configuration_arr[0].date}
                                                    onChange={(e) => {
                                                        let temp = Configuration_arr.map(a => { return { ...a } })
                                                        temp[0].date = e.target.value
                                                        setConfiguration_arr(temp)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-12 my-2">
                                                <label className="fs-5 fw-bold mb-2">Notes</label>
                                                <textarea className="form-control form-control-solid" rows="3" value={Configuration_arr[0].notes}
                                                    onChange={(e) => {
                                                        let temp = Configuration_arr.map(a => { return { ...a } })
                                                        temp[0].notes = e.target.value
                                                        setConfiguration_arr(temp)
                                                    }}
                                                    placeholder={""}>
                                                </textarea>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    PaymentMode.value == "Credit_Card" &&
                                    <>
                                        <div className="row mb-5">
                                            <div className="col-md-10">
                                                <label className="required fs-5 fw-bold mb-2">Card Holder Name</label>
                                                <input type="text" className="form-control form-control-solid" value={Configuration_arr[0].card_holder_name}
                                                    onChange={(e) => {
                                                        let temp = Configuration_arr.map(a => { return { ...a } })
                                                        temp[0].card_holder_name = e.target.value
                                                        setConfiguration_arr(temp)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-5">
                                                <label className="required fs-5 fw-bold mb-2">Card Number</label>
                                                <input type="text" className="form-control form-control-solid" value={Configuration_arr[0].card_no}
                                                    onChange={(e) => {
                                                        let temp = Configuration_arr.map(a => { return { ...a } })
                                                        temp[0].card_no = e.target.value
                                                        setConfiguration_arr(temp)
                                                    }} />
                                            </div>
                                            <div className="col-md-5">
                                                <label className="required fs-5 fw-bold mb-2">Expiry Date</label>
                                                <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={Configuration_arr[0].expiry_date}
                                                    onChange={(e) => {
                                                        let temp = Configuration_arr.map(a => { return { ...a } })
                                                        temp[0].expiry_date = e.target.value
                                                        setConfiguration_arr(temp)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-12 my-2">
                                                <label className="fs-5 fw-bold mb-2">Notes</label>
                                                <textarea className="form-control form-control-solid" rows="3" value={Configuration_arr[0].notes}
                                                    onChange={(e) => {
                                                        let temp = Configuration_arr.map(a => { return { ...a } })
                                                        temp[0].notes = e.target.value
                                                        setConfiguration_arr(temp)
                                                    }}
                                                    placeholder={""}>
                                                </textarea>
                                            </div>
                                        </div>
                                    </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary rounded me-auto" onClick={() => { Config_set_up(PaymentMode.value); }}>Reset</button>
                    <button className="btn btn-success rounded" onClick={() => { setDenominationModalShow(false); }}>Save</button>
                </Modal.Footer>
            </Modal>
            <Modal show={progressModalShow} onHide={() => { setProgressModalShow(false); setProgressStatus([]); }} centered>
                <Modal.Body>
                    {flowApiState === true && (
                        <div className="text-center">
                            <span>Loading...</span>
                            <svg width="50" height="15" viewBox="0 45 100 10">
                                <g transform="translate(20 50)"><circle cx="0" cy="0" r="6" fill="#e15b64"><animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(40 50)"><circle cx="0" cy="0" r="6" fill="#f8b26a"><animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(60 50)"><circle cx="0" cy="0" r="6" fill="#abbd81"><animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(80 50)"><circle cx="0" cy="0" r="6" fill="#81a3bd"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                            </svg>
                        </div>
                    )}

                    {flowApiState === false && (
                        <>
                            <div className="position-absolute top-0 end-0 p-5">
                                <div onClick={() => { setProgressModalShow(false); setProgressStatus([]) }} className="cursor-pointer">
                                    <i className="bi bi-x-circle fs-1 text-danger"></i>
                                </div>
                            </div>
                            <div className='container mt-6'>
                                {progressStatus.length === 0 && <p>No Amount Preview Available</p>}
                                <Timeline>
                                    {progressStatus &&
                                        progressStatus.map((obj) => (
                                            <Timeline.Item key={obj._id} color="green">
                                                <div className="d-flex flex-wrap">
                                                    <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                        <p className={`fw-bold text-${obj.log_status === "Pending" ? "warning" : "success"} mb-0`}>
                                                            {obj.log_status}
                                                        </p>
                                                        <p className="fw-mormal timeline-content text-primary mb-0">
                                                            {baseCurrency.currency_symbol} {obj.payment_amount}
                                                        </p>
                                                    </div>
                                                    <div className="d-flex flex-column align-items-center ps-5">
                                                        <p className="fw-bold text-gray-800 fs-6 mb-0">Timestamp</p>
                                                        <p className="fw-bold text-gray-800 fs-6">{moment(obj.log_date_time).utcOffset(timezone_change).format("lll")}</p>
                                                    </div>
                                                </div>
                                            </Timeline.Item>
                                        ))}
                                </Timeline>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal >
            <Modal show={addAccHeadModalShow} onHide={() => { setAddAccHeadModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>New Head</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setAddAccHeadModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Account Category</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <Select
                                    className="form-control form-control-solid"
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    options={categoryList.map(x => { return { label: x.category_name, value: x.cid, headArray: x.headArray } })}
                                    onChange={(val) => {
                                        setAccountHeadList(val.headArray);
                                        setNewHead({ ...newHead, uq_ac: val.value, parent: "" })
                                    }}
                                    placeholder="Select Category"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Name</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    onChange={(e) => { setNewHead({ ...newHead, name: e.target.value }) }}
                                    placeholder='Name of Head'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Code</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    onChange={(e) => { setNewHead({ ...newHead, code: e.target.value }) }}
                                    placeholder='Codename of Head'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Sub</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="checkbox" className=""
                                    onChange={(e) => { setNewHead({ ...newHead, sub: e.target.checked ? 1 : 0 }) }}
                                />
                            </div>
                        </div>
                        {
                            newHead.sub ?
                                <>
                                    <div className="d-flex justify-content-between mb-5">
                                        <div className="col-3 my-auto">
                                            <label className="required fs-5 mb-2">Parent Head</label>
                                        </div>
                                        <div className='col-9 my-auto'>
                                            <Select
                                                className="form-control form-control-solid"
                                                styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                options={accountheadList.map(x => { return { label: x.name, value: x.hid } })}
                                                onChange={(val) => {
                                                    setNewHead({ ...newHead, parent: val.value })
                                                }}
                                                placeholder="Select Parent Head"
                                            />
                                        </div>
                                    </div>
                                </>
                                : null}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Description</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <textarea type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, description: e.target.value }) }}
                                    placeholder='Description for account head'
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded me-auto" onClick={() => { setAddAccHeadModalShow(false) }}>Close</button>
                    {
                        // write  &&
                        <button className="btn btn-success rounded" data-kt-indicator={submitButton ? "on" : "off"} disabled={submitButton} onClick={() => { newHeadSubmit() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>

            <Drawer width={window.innerWidth > 1200 ? 800 : 'auto'} styles={{ body: { padding: "1.5rem" } }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
            </a>}
                extra={
                    <Space>

                    </Space>
                }

            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Product_details" && "active"}`} onClick={(e) => { setnavtype("Product_details"); }}>Product Details</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Transactions" && "active"}`} onClick={(e) => { setnavtype("Transactions"); }}>Associated GR</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Bill History" && "active"}`} onClick={(e) => { setnavtype("Bill History"); }}>Bill History</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Payment History" && "active"}`} onClick={(e) => { setnavtype("Payment History"); }}>Payment History</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card">
                    {(navtype === "Overview") ?
                        <>
                            <div
                                className="card border-primary mb-3 mt-2"
                                style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                            >
                                <div className="card-header cursor-pointer py-3">
                                    <div className="card-title m-0">
                                        {billDetails !== null &&
                                            <h3 className="fw-bold m-0">
                                                #{billDetails.bill_number}
                                            </h3>
                                        }
                                    </div>
                                </div>
                                <div className="card-body p-3">
                                    {(additonalDetailsFlag !== true && billDetails !== null) ?
                                        <>
                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Bill Date</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {/* {financerDetails.order_number} */}
                                                            {moment(billDetails.bill_date).format("ll")}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Due Date</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {moment(billDetails.due_date).format("ll")}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Associated GR</label>
                                                    <div className="col-lg-8">
                                                        {
                                                            billDetails.goods_received_id.map((x, i) => {
                                                                return <span key={i} className="badge badge-info mx-1 rounded">{x.gr_number}</span>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Internal Notes</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {billDetails.internal_notes !== "" ? billDetails.internal_notes : "No notes provided"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Term</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {billDetails.term == null ? "No term period added" : (billDetails.term.term_name + "---" + billDetails.term.term_days + " days")}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Terms and Conditions</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {billDetails.terms_and_conditions !== "" ? billDetails.terms_and_conditions : "No terms and conditions provided"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Status</label>
                                                    <div className="col-lg-8">
                                                        <div style={{ position: "relative", display: "inline-block" }} >
                                                            <button className={`py-2 me-1 rounded btn btn-sm btn-${billDetails.add_status === "BILL_PENDING_APPROVAL" ? "warning" : "secondary"}`} onClick={() => { setApprovalChainPopup(true); }} onBlur={() => { setApprovalChainPopup(false) }}>
                                                                {billDetails.add_status.replace("BILL", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}
                                                            </button>
                                                            <div style={{ position: "absolute", right: "0px", top: "0px", boxShadow: "0 2px 5px 0 rgb(0 0 0 / 26%)", backgroundColor: "#FFFFFF", color: "black", padding: "1rem", width: "25rem", borderRadius: "0.5rem", transition: "all 0.25s ease-in-out", zIndex: 1, opacity: approvalChainPopup ? "1" : "0", visibility: approvalChainPopup ? "visible" : "hidden" }}>
                                                                {
                                                                    billDetails.approval_info.type === "multilevel_approval" ?
                                                                        <>
                                                                            <div className='text-center border-bottom fs-4'>Multilevel Approval</div>
                                                                            <div>
                                                                                {
                                                                                    billDetails.approval_info.value.map((obj, i) => {
                                                                                        return (
                                                                                            <div key={i} className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
                                                                                                <div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
                                                                                                <div className='flex-grow-1 text-start'>
                                                                                                    <div className='fs-4'>Level {obj.level}</div>
                                                                                                    {
                                                                                                        obj.user_value.map((val, j) => {
                                                                                                            return <div key={j} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
                                                                                                        })
                                                                                                    }
                                                                                                </div>
                                                                                                <div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                }

                                                                                <div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
                                                                                    <i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
                                                                                    <div className='fs-4'>Approved</div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        billDetails.approval_info.type === "custom_approval" &&
                                                                        <>
                                                                            <div className='text-center border-bottom fs-4'>Custom Approval</div>
                                                                            <div>
                                                                                <div className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
                                                                                    <div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
                                                                                    <div className='flex-grow-1 text-start'>
                                                                                        <div className='fs-4'>{billDetails.approval_info.value[0].user_type}</div>
                                                                                        {
                                                                                            billDetails.approval_info.value[0].user_value.map((val, i) => {
                                                                                                return <div key={i} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                    <div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
                                                                                </div>
                                                                                <div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
                                                                                    <i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
                                                                                    <div className='fs-4'>Approved</div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                <h5 className="fw-bold mb-3">User Details</h5>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">User Type</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {billDetails.user_type}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">User Name</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {billDetails.doc_user_name}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">User Email</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {billDetails.doc_user_email}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                <h5 className="fw-bold mb-3">Address Details</h5>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Billing Address</label>
                                                    <div className="col-lg-8">
                                                        <div className="location">
                                                            <i className="fas fa-map-marker-alt"></i> {billDetails.billing_address.city}, {billDetails.billing_address.state}
                                                        </div>
                                                        <div className="pincode">
                                                            <i className="fas fa-thumbtack"></i> {billDetails.billing_address.pincode}
                                                        </div>
                                                        <div className="country">
                                                            <i className="fas fa-globe"></i> {billDetails.billing_address.country}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Shipping Address</label>
                                                    <div className="col-lg-8">
                                                        <div className="location">
                                                            <i className="fas fa-map-marker-alt"></i> {billDetails.shipping_address.city}, {billDetails.shipping_address.state}
                                                        </div>
                                                        <div className="pincode">
                                                            <i className="fas fa-thumbtack"></i> {billDetails.shipping_address.pincode}
                                                        </div>
                                                        <div className="country">
                                                            <i className="fas fa-globe"></i> {billDetails.shipping_address.country}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                <h5 className="fw-bold mb-3">Other Details</h5>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {billDetails.branch_name}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">User Name</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {billDetails.doc_user_name}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">User Email</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {billDetails.doc_user_email}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    }
                                </div>
                            </div>
                        </>
                        :
                        navtype === "Product_details" ?
                            <>
                                <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                                    {(additonalDetailsFlag !== true && billDetails !== null) ?
                                        <>
                                            <div className="card-body p-9">
                                                <div>
                                                    {billDetails.item_array.length > 0 && billDetails.item_array.map((item, indx4) => {
                                                        return (
                                                            <div className="payment-details-box" key={indx4} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Product Name</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {item.item_name}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Rate</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {baseCurrency.currency_symbol} {item.rate}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Quantity</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {item.quantity}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Total</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {baseCurrency.currency_symbol} {Math.round((((item.quantity * item.rate) - (item.discount_type === "amount" ? item.discount_unit : item.quantity * item.rate * item.discount_unit / 100)) + (item.taxable === 0 ? 0 : ((item.quantity * item.rate) - (item.discount_type === "amount" ? item.discount_unit : item.quantity * item.rate * item.discount_unit / 100)) * (item.tax_group_percentage / 100))) * decimalPlace) / decimalPlace}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    }
                                </div>
                            </>
                            :
                            navtype === "Transactions" ?
                                <>
                                    <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                                        {(additonalDetailsFlag !== true && billDetails !== null) ?
                                            <>
                                                <div className="card-body p-9">
                                                    <div>
                                                        {receiveGoodsRecords.length > 0 && receiveGoodsRecords.map((gr, indx3) => {
                                                            return (
                                                                <div className="payment-details-box" key={indx3} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">GR No</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {gr.gr_number}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">User</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {gr.user_type} - {gr.doc_user_name}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {gr.branch_name}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Warehouse</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {gr.warehouse_name}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Created On</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {moment(gr.add_date_time).format("lll")}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <span className="fw-bold fs-5 text-primary">Received Items</span>
                                                                        <div className='mx-10'>
                                                                            {
                                                                                gr.item_array.map((x, i) => {
                                                                                    return (
                                                                                        <div key={i} className="fs-5 fw-semibold d-flex justify-content-between">
                                                                                            <span>{x.item_name}</span>
                                                                                            <span>{x.received_qty} units</span>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                        }
                                    </div>
                                </>
                                :
                                navtype === "Bill History" ?
                                    <>
                                        {(additonalDetailsFlag !== true && billDetails !== null) ?
                                            <>
                                                {billDetails != undefined &&
                                                    <div className="card-body p-9">
                                                        {billDetails.bills_status_logs.length > 0 && billDetails.bills_status_logs.map((obj, index) => {
                                                            return (
                                                                <>
                                                                    <div key={index} className="m-0">
                                                                        <div className="d-flex align-items-sm-center mb-5">
                                                                            <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                                <div className="flex-grow-1 me-2">
                                                                                    {obj.bill_status === "BILL_DRAFT" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Draft</span> : obj.bill_status === "BILL_CANCELLED" ? <span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span> : obj.bill_status === "BILL_PENDING_APPROVAL" ? <><span className="badge badge-lg badge-warning fw-bold my-2">Pending Approval</span></> : obj.bill_status === "BILL_CONFIRMED" ? <span className="badge badge-lg badge-success fw-bold my-2">Confirmed</span> : obj.bill_status === "BILL_FINALIZED" ? <span className="badge badge-lg badge-success fw-bold my-2">Finalized</span> : <span className="badge badge-lg badge-danger fw-bold my-2">{obj.bill_status.replace("BILL_", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="timeline">
                                                                            <div className="timeline-item align-items-center mb-7">
                                                                                <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                                <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                                    <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                                    <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                                </svg>
                                                                                </span>
                                                                                <div className="timeline-content m-0">
                                                                                    <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                                    <span className="fs-6 fw-bold text-gray-800">{moment(obj.timestamp).format("lll")} </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="timeline-item align-items-center">
                                                                                <div className="timeline-line w-40px"></div>
                                                                                <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                                    <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                                    <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                                </svg>
                                                                                </span>
                                                                                <div className="timeline-content m-0">
                                                                                    <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                                    <span className="fs-6 fw-bold text-gray-800">{obj.user}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {billHistoryDetails.length > 1 &&
                                                                        <div className="separator separator-dashed my-6"></div>
                                                                    }
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                }
                                            </>
                                            :
                                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                        }
                                    </> :
                                    navtype === "Payment History" &&
                                    <>
                                        <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                                            {(additonalDetailsFlag !== true && billDetails !== null) ?
                                                <>
                                                    <div className="card-body p-9">
                                                        <div>
                                                            {billDetails.payment_logs.length == 0 ?
                                                                <span className='text-gray-600'>No history available.</span>
                                                                : billDetails.payment_logs.map((item, indx4) => {
                                                                    return (
                                                                        <div className="payment-details-box" key={indx4} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                            <div className="row mb-2">
                                                                                <label className="col-lg-4 fw-semibold text-muted">Status</label>
                                                                                <div className="col-lg-8">
                                                                                    {item.log_status === "Pending" ? <span className="badge badge-lg badge-warning fw-bold my-2">Pending</span> : <span className="badge badge-lg badge-succces fw-bold my-2">Paid</span>}
                                                                                </div>
                                                                            </div>
                                                                            <div className="row mb-2">
                                                                                <label className="col-lg-4 fw-semibold text-muted">timestamp</label>
                                                                                <div className="col-lg-8">
                                                                                    <span className="fw-bold fs-6 text-gray-800">
                                                                                        {moment(item.log_date_time).format("lll")}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="row mb-2">
                                                                                <label className="col-lg-4 fw-semibold text-muted">Amount</label>
                                                                                <div className="col-lg-8">
                                                                                    <span className="fw-bold fs-6 text-gray-800">
                                                                                        {billDetails.bill_currency.currency_symbol} {item.payment_amount}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                            }
                                        </div>
                                    </>
                    }
                </div>
            </Drawer>
        </>);

};

export default EditPaymentDetails;
